import type Icon from 'ui/src/types/icons'

export const alignOptions = ['left', 'center', 'right'] as const

type Align = (typeof alignOptions)[number]

export function iconFromAlignOption(align: Align): Icon {
    switch (align) {
        case 'center':
            return 'align-center'
        case 'left':
            return 'align-left'
        case 'right':
            return 'align-right'
    }
}

export function labelFromAlignOption(align: Align): string {
    switch (align) {
        case 'center':
            return 'Center'
        case 'left':
            return 'Left'
        case 'right':
            return 'Right'
    }
}

export default Align
